var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 26.301,
    viewBox: "0 0 23 26.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_783",
    "data-name": "\\uC0AC\\uAC01\\uD615 783",
    width: 23,
    height: 26.301,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_163",
    "data-name": "\\uADF8\\uB8F9 163",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_163-2",
    "data-name": "\\uADF8\\uB8F9 163",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_587",
    "data-name": "\\uD328\\uC2A4 587",
    d: "M9.028,13.839a6.857,6.857,0,1,1,6.857-6.857,6.866,6.866,0,0,1-6.857,6.857m0-12.5a5.644,5.644,0,1,0,5.645,5.645A5.65,5.65,0,0,0,9.028,1.337",
    transform: "translate(2.471 0.142)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_588",
    "data-name": "\\uD328\\uC2A4 588",
    d: "M9.169,14.248a7.124,7.124,0,1,1,7.124-7.124,7.131,7.131,0,0,1-7.124,7.124m0-13.714a6.59,6.59,0,1,0,6.59,6.59A6.6,6.6,0,0,0,9.169.535m0,12.5a5.911,5.911,0,1,1,5.914-5.91,5.918,5.918,0,0,1-5.914,5.91m0-11.287a5.376,5.376,0,1,0,5.379,5.377A5.383,5.383,0,0,0,9.169,1.747",
    transform: "translate(2.33 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_589",
    "data-name": "\\uD328\\uC2A4 589",
    d: "M21.983,18.478H.732a.606.606,0,0,1-.607-.605,11.233,11.233,0,1,1,22.465,0,.606.606,0,0,1-.607.605M1.357,17.265h20a10.019,10.019,0,0,0-20,0",
    transform: "translate(0.142 7.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_590",
    "data-name": "\\uD328\\uC2A4 590",
    d: "M22.125,18.886H.874A.875.875,0,0,1,0,18.014a11.5,11.5,0,0,1,23,0,.875.875,0,0,1-.874.872M11.5,7.05A10.977,10.977,0,0,0,.535,18.014a.339.339,0,0,0,.34.338H22.125a.339.339,0,0,0,.34-.338A10.977,10.977,0,0,0,11.5,7.05M21.785,17.674H1.214l.017-.282a10.287,10.287,0,0,1,20.537,0Zm-20-.535H21.212a9.752,9.752,0,0,0-19.425,0",
    transform: "translate(0 7.414)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoin);
export default __webpack_public_path__ + "static/media/join.3359824685497ec0c9478d10396eff5f.svg";
export { ForwardRef as ReactComponent };